import { connect } from 'react-redux'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import Navigation from 'support/navigation'
import i18n from 'support/i18n'

const mapStateToProps = (state, ownProps) => ({
  title: 'Successfully!',
  description: ownProps.description,
  mainButtonText: 'Okay',
})

const mapDispatchToProps = dispatch => {
  return {

    // mainButtonAction: () => dispatch(hideDialog()),
    mainButtonAction: () => {
      dispatch(hideDialog())
      // dispatch(Navigation.navigateToAdminCreateSME)
      dispatch(window.location.reload())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
